import shuffle from 'lodash/shuffle';
import { stepModel } from '../step/step-model';
import { stepTypes } from '../step/step-constants';

var isSequencingStep = function isSequencingStep(step) {
  return step.type === stepTypes.SEQUENCING;
};

var getCorrectValues = function getCorrectValues(step) {
  return [].concat(step.correct).map(function (id) {
    return step.content[0].find(function (c) {
      return c.id === id;
    });
  });
};

var getAnswers = function getAnswers(step, values) {
  return values.map(function (value, index) {
    var correct = value.id === step.correct[index];
    // if this is a text-based sequence and there are two answers with
    //  identical text and the other one is correct, mark this as correct
    if (!correct && value.text) {
      var correctValue = values.find(function (v) {
        return v.id === step.correct[index];
      });
      correct = correctValue.text === value.text;
    }
    return { answer: value.id, correct: correct };
  });
};

var parseSequencingData = function parseSequencingData(step) {
  var choices = step.content[0];
  var doShuffle = stepModel.isRandomOrdering(step) && stepModel.environmentNeedsShuffledChoices();
  if (doShuffle) {
    var givenChoices = [];
    var shuffleableChoices = [];
    var isVertical = !!step.behavior && step.behavior.orientation === 'vertical';
    if (isVertical) {
      choices.forEach(function (choice, ndx) {
        if (choice.promptType === 'given') {
          givenChoices.push({
            choice: choice,
            index: ndx
          });
        } else {
          shuffleableChoices.push(choice);
        }
      });
    } else {
      shuffleableChoices = choices;
    }
    var needsShuffling = true;
    while (needsShuffling) {
      choices = shuffle(shuffleableChoices);
      for (var i = 0; i < givenChoices.length; i++) {
        var givenChoice = givenChoices[i];
        choices.splice(givenChoice.index, 0, givenChoice.choice);
      }
      // make sure randomized order is not the same as correct order
      needsShuffling = stepModel.areAnswersCorrect(step, getAnswers(step, choices));
    }
  }
  return { choices: choices };
};

export var stepSequencingModel = {
  isSequencingStep: isSequencingStep,
  getCorrectValues: getCorrectValues,
  getAnswers: getAnswers,
  parseSequencingData: parseSequencingData
};